import sharedSupabase from '../config/supabase';

/**
 * Ask the read-only scenario explainer to word deterministic purchasing facts.
 * The Edge Function falls back to calculated copy, so callers always receive a
 * useful explanation even when the model is unavailable.
 */
export async function explainPurchaseScenario(storeId, scenario) {
  const numericStoreId = Number(storeId);
  if (!Number.isFinite(numericStoreId) || numericStoreId <= 0) {
    throw new Error('A store is required to explain this purchase scenario.');
  }
  const { data, error } = await sharedSupabase.functions.invoke(
    'purchase-scenario-explanation',
    { body: { store_id: numericStoreId, scenario } },
  );
  if (error) throw error;
  if (!data || typeof data.explanation !== 'string' || !data.explanation.trim()) {
    throw new Error('The scenario explanation was empty.');
  }
  return data;
}
